module.exports = __webpack_public_path__ + "f319041d368151feec1ea6c01fb58a12.pdf";